const dev = {
  APIURL: "https://devapi.masternaukri.com",
  TENANT_KEY: "044a030b-a0cd-412b-8539-aa3a80a8ecd5",
  // TENANT_KEY: "044a030b-a0cd-412b-8539-aa3a80a8ecd1",
  MEDIAPATH: "https://kid-ex.com",
  IMGPATH: "https://kid-ex.com/skin/images/",
}
const prod = {
  APIURL: window?._env_?.API_URL,
  TENANT_KEY: window?._env_?.TENANT_KEY,
  MEDIAPATH: "https://kid-ex.com",
  IMGPATH: "https://kid-ex.com/skin/images/",
}

export const config = process.env.NODE_ENV === "development" ? dev : prod;

export default { config };